module.exports = "/images/ill-jar-coins.svg?1df5c31be58fa507f76bbfde2f12786e";